document.addEventListener('DOMContentLoaded', function() {
  const lastColumRow = document.querySelectorAll('.rte .row-table:last-child');
  const numArray = []
  lastColumRow.forEach(function(elem) {
     numArray.push(elem.offsetHeight);
  });
  const highest = Math.max(...numArray);
  lastColumRow.forEach(function(elem) {
     elem.style.cssText = 'height: '+highest+'px;align-items: flex-start;';
  });
}); //DOMContentLoaded